import { useLocalization } from "@fluent/react";
import { useGetCreditCardProductsQuery } from "@lending/hooks/queries/CreditCardProduct/useGetCreditCardProductsQuery";
import { SelectedProductTag } from "./SelectedProductTag";
import { useStore } from "../../contexts/StoreContext";

export function CreditCardSelectedProductTag() {
  const { l10n } = useLocalization();
  const { data } = useStore();
  const { creditCardProductsData } = useGetCreditCardProductsQuery();

  if (!creditCardProductsData) {
    return null;
  }

  const selectedProduct = creditCardProductsData.results.find(
    (product) => product.id === data.selectedProduct
  );

  const productName =
    selectedProduct?.name ??
    l10n.getString("product-selection-credit-card-name", null, "Credit card");

  return <SelectedProductTag productName={productName} iconClass="narmi-icon-credit-card1" />;
}
